import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { ProductCard } from "../components/ProductCard";
import { PageHeader } from "../components/PageHeader";

export default function Watches() {
  const [items, setItems] = useState(null);
  useEffect(() => { api("/watches").then((d) => setItems(Array.isArray(d) ? d : (d.products || d.watches || []))).catch(() => setItems([])); }, []);
  if (!items) return <Loader />;
  return (
    <div className="animate-fade-in-up max-w-5xl mx-auto">
      <PageHeader title="مراقبة الأسعار" />
      {items.length === 0 ? <EmptyState icon={Bell} title="لا توجد منتجات تحت المراقبة" /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {items.map((p) => <ProductCard key={p.product_id} item={p} />)}
        </div>
      )}
    </div>
  );
}
